export default "__VITE_ASSET__e3a51ea4__"